import {
  NavbarRow,
  NavPill,
  LoginPill,
  LoginButton,
  HeaderLogoHomeButton,
  HeaderPartnerLogoWrapper,
  SwachhBharatHitArea,
  MinorityAffairsHitArea,
  Menu,
  MenuWrapper,
  Dropdown,
  DropdownItem,
  Divider,
  NavButton,
  MobileMenuToggle,
  MobileBranding,
} from "./Header.styles";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { FaBars, FaChevronDown, FaXmark } from "react-icons/fa6";
import schemeMenuItems from "../../../schemes/data/schemeMenuItems";
import rtiMenuItems from "../../../rightToInformation/data/rtiMenuItems";
import careerMenuItems from "../../../career/data/careerMenuItems";
import resourceMenuItems from "../../../resources/data/resourceMenuItems";
import complianceMenuItems from "../../../resources/data/complianceMenuItems";
import achievementMenuItems from "../../../achievements/data/achievementMenuItems";
import nmdfcLogo from "../../../../assets/images/NMDFClogo 2.png";
import partnerLogos from "../../../../assets/images/jansamtrh&mom.svg";
import { requestExternalNavigation } from "../../../../utils/externalNavigation";

const menuItems = [
  "About Us",
  "Schemes",
  "Right to Information",
  "Work With Us",
  "Resources",
  "Achievements",
  "Compliance",
  "Contact Us",
  // "Employee Corner",
];

const aboutUsItems = [
  { label: "About NMDFC", path: "/about/about-nmdfc" },
  { label: "Vision & Mission", path: "/about/vision-mission" },
  { label: "Board of Directors", path: "/about/board-directors" },
  { label: "Our Team", path: "/about/our-team" },
  { label: "Organization Chart", path: "/about/organization-chart" },
  { label: "Capital Structure", path: "/about/capital-structure" },
  { label: "State Channelizing Agencies(SCAs)", path: "/about/scas-partners" },
  { label: "Target Groups", path: "/about/target-groups" },
  { label: "Media Gallery", path: "/about/events" },
];

const dropdownItemsByMenu = {
  "About Us": aboutUsItems,
  Schemes: schemeMenuItems,
  "Right to Information": rtiMenuItems,
  "Work With Us": careerMenuItems,
  Resources: resourceMenuItems,
  Achievements: achievementMenuItems,
  Compliance: complianceMenuItems,
};
const pathByMenu = {
  Career: "/career/available-opportunities",
};

const Navbar = ({ embeddedInHeaderBackdrop = false, compact = false, onNavigate }) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuWrapperRef = useRef(null);
  const menuButtonRefs = useRef([]);
  const mobileMenuToggleRef = useRef(null);
  const pressedDropdownRef = useRef(null);
  const dismissedHoverRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (openDropdownIndex === null && !mobileMenuOpen) return;

    const handleOutsideClick = (event) => {
      if (
        openDropdownIndex !== null &&
        !menuButtonRefs.current[openDropdownIndex]?.parentElement.contains(event.target)
      ) {
        setOpenDropdownIndex(null);
      }
      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(event.target)
      ) {
        setOpenDropdownIndex(null);
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [openDropdownIndex, mobileMenuOpen]);
  const closeMenus = () => {
    setOpenDropdownIndex(null);
    setMobileMenuOpen(false);
  };

  const handleMenuKeyDown = (event) => {
    if (event.key !== "Escape") return;
    if (openDropdownIndex !== null) {
      event.preventDefault();
      event.stopPropagation();
      menuButtonRefs.current[openDropdownIndex]?.focus();
      setOpenDropdownIndex(null);
    } else if (mobileMenuOpen) {
      event.preventDefault();
      event.stopPropagation();
      setMobileMenuOpen(false);
      mobileMenuToggleRef.current?.focus();
    }
  };

  // Closes dropdown when focus leaves its menu.
  const handleMenuBlur = (event, index) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setOpenDropdownIndex((current) => current === index ? null : current);
    }
  };

  const completeNavigation = ({ afterRoutePaint = false } = {}) => {
    closeMenus();

    if (!onNavigate) {
      return;
    }

    if (afterRoutePaint && typeof window !== "undefined" && window.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        onNavigate();
      });
      return;
    }

    onNavigate();
  };

  const handleMenuClick = (item, index) => {
    const dropdownItems = dropdownItemsByMenu[item] || [];

    if (dropdownItems.length > 0) {
      // Use the state at press time: focus/blur can run before the click.
      const pressed = pressedDropdownRef.current;
      const wasOpen = pressed?.index === index ? pressed.wasOpen : openDropdownIndex === index;
      pressedDropdownRef.current = null;
      dismissedHoverRef.current = wasOpen ? index : null;
      setOpenDropdownIndex(wasOpen ? null : index);
    } else if (item === "Contact Us") {
      navigate("/contact");
      completeNavigation({ afterRoutePaint: true });
    } else if (item === "Employee Corner") {
      navigate("/login");
      completeNavigation({ afterRoutePaint: true });
    } else {
      closeMenus();

      if (pathByMenu[item]) {
        navigate(pathByMenu[item]);
        completeNavigation({ afterRoutePaint: true });
      }
    }
  };

  const handleDropdownItemClick = (item) => {
    navigate(item.path);
    completeNavigation({ afterRoutePaint: true });
  };



  const handleLogoClick = () => {
    navigate("/");
    completeNavigation({ afterRoutePaint: true });
  };


  return (
    <NavbarRow $embedded={embeddedInHeaderBackdrop} $compact={compact}>
      <MobileBranding>
        <button
          type="button"
          className="mobile-brand-home"
          aria-label="Go to NMDFC home page"
          onClick={handleLogoClick}
        >
          <img src={nmdfcLogo} alt="NMDFC" />
        </button>
        <div className="mobile-partner-logos">
          <span className="mobile-partner-logo-wrap">
            <img
              src={partnerLogos}
              alt="Swachh Bharat and Ministry of Minority Affairs"
            />
            <SwachhBharatHitArea
              href="https://swachhatahiseva.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Swachhata Hi Seva website"
            >

              <span className="sr-only">Swachhata Hi Seva</span>

            </SwachhBharatHitArea>
            <MinorityAffairsHitArea
              href="https://minorityaffairs.gov.in/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Ministry of Minority Affairs website"
            >

              <span className="sr-only">Ministry of Minority Affairs</span>

            </MinorityAffairsHitArea>
          </span>
        </div>
      </MobileBranding>
      <HeaderLogoHomeButton
        type="button"
        aria-label="Go to NMDFC home page"
        onClick={handleLogoClick}
        $compact={compact}
      >
        <img src={nmdfcLogo} alt="NMDFC home" />
      </HeaderLogoHomeButton>
      <HeaderPartnerLogoWrapper $compact={compact}>
        <img
          src={partnerLogos}
          alt="Swachh Bharat and Ministry of Minority Affairs"
        />
        <SwachhBharatHitArea
          href="https://swachhatahiseva.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Swachhata Hi Seva website"
        >

          <span className="sr-only">Swachhata Hi Seva</span>

        </SwachhBharatHitArea>
        <MinorityAffairsHitArea
          href="https://minorityaffairs.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Ministry of Minority Affairs website"
        >

          <span className="sr-only">Ministry of Minority Affairs</span>

        </MinorityAffairsHitArea>
      </HeaderPartnerLogoWrapper>

      <NavPill $compact={compact}>
        <MenuWrapper ref={menuWrapperRef} $compact={compact} onKeyDown={handleMenuKeyDown}>
          <MobileMenuToggle
            ref={mobileMenuToggleRef}
            type="button"
            aria-expanded={mobileMenuOpen}
            aria-controls="site-navigation-menu"
            onClick={() => {
              setOpenDropdownIndex(null);
              setMobileMenuOpen((isOpen) => !isOpen);
            }}
          >
            {mobileMenuOpen ? <FaXmark aria-hidden="true" /> : <FaBars aria-hidden="true" />}
            Menu
          </MobileMenuToggle>
          <Menu id="site-navigation-menu" $compact={compact} $mobileOpen={mobileMenuOpen}>
            {menuItems.map((item, index) => {
              const dropdownItems = dropdownItemsByMenu[item] || [];
              const hasDropdown = dropdownItems.length > 0;
              const isOpen = openDropdownIndex === index;

              return (
                <React.Fragment key={item}>
                  <div
                    className="relative flex items-center"
                    onMouseEnter={hasDropdown ? () => {
                      if (dismissedHoverRef.current !== index) setOpenDropdownIndex(index);
                    } : undefined}
                    onMouseLeave={() => {
                      if (dismissedHoverRef.current === index) dismissedHoverRef.current = null;
                    }}
                    onBlur={hasDropdown ? (event) => handleMenuBlur(event, index) : undefined}
                  >
                    <NavButton
                      ref={(element) => { menuButtonRefs.current[index] = element; }}
                      id={`navigation-trigger-${index}`}
                      type="button"
                      onPointerDown={hasDropdown ? () => {
                        pressedDropdownRef.current = { index, wasOpen: openDropdownIndex === index };
                      } : undefined}
                      onPointerCancel={() => { pressedDropdownRef.current = null; }}
                      onKeyDown={() => { pressedDropdownRef.current = null; }}
                      onClick={() => handleMenuClick(item, index)}
                      aria-controls={hasDropdown ? `navigation-dropdown-${index}` : undefined}
                      aria-expanded={hasDropdown ? isOpen : undefined}
                      $active={isOpen}
                      $compact={compact}
                    >
                      {item}
                      {hasDropdown && (
                        <FaChevronDown
                          size={compact ? 11 : 14}
                          className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
                        />
                      )}
                    </NavButton>

                    {hasDropdown && (
                      <Dropdown id={`navigation-dropdown-${index}`} aria-labelledby={`navigation-trigger-${index}`} $open={isOpen}>
                        {dropdownItems.map((dropdownItem) => (
                          <DropdownItem key={dropdownItem.path}>
                          <button
                              type="button"
                              onClick={() => handleDropdownItemClick(dropdownItem)}
                            className="w-full text-left text-[#0b5d82] font-medium hover:text-[#0a4a65] bg-transparent border-none cursor-pointer"
                          >
                              {dropdownItem.label}
                          </button>
                        </DropdownItem>
                      ))}
                    </Dropdown>
                  )}
                  </div>

                {index < menuItems.length - 1 && <Divider $compact={compact} />}
              </React.Fragment>
              );
            })}
          </Menu>
        </MenuWrapper>

        <LoginPill $compact={compact}>
          <LoginButton
            type="button"
            onClick={() => {
              requestExternalNavigation("https://milannmdfc.org/");
              completeNavigation();
            }}
            $compact={compact}
          >
            Register/Login
          </LoginButton>
        </LoginPill>
      </NavPill>
    </NavbarRow>
  );
};

export default Navbar
